"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrCadDSNClasses = void 0;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const xmlutil_1 = require("../../common/xmlutil");
const xmlTransformer_1 = require("./xmlTransformer");
const portOccurrenceNormalization_1 = require("../../portOccurrenceNormalization");
var OrCadDSNClasses;
(function (OrCadDSNClasses) {
    class Design {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new Design((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (Design._spec ??= {
                DesignExportVersion: ['$DesignExportVersion', 'number'],
                Name: ['$name', 'string'],
                ObjectType: ['$objectType', new xmlTransformer_1.EnumArg(['SCHEMATIC'])],
                RootName: ['$rootName', 'string'],
                UseExplicitDbId: ['$useExplicitDbId', 'boolean'],
                DateTime: ['DesignDateTime', DateTime],
                DefaultValues: ['DefaultValues', DefaultValues],
                Cache: ['Cache', Cache],
                Netgroup: ['Netgroup', new xmlTransformer_1.OptionalArg(Netgroup)],
                Schematic: ['Schematic', [Schematic]],
                Occurrences: ['Occurrences', Occurrences],
                Cis: ['CIS', CIS],
                XmlnsXsd: ['$xmlns:xsd', new xmlTransformer_1.OptionalArg('string')],
                XmlnsXsi: ['$xmlns:xsi', new xmlTransformer_1.OptionalArg('string')],
                XsiNamespaceSchemaLocation: ['$xsi:noNamespaceSchemaLocation', new xmlTransformer_1.OptionalArg('string')],
            })));
        }
    }
    OrCadDSNClasses.Design = Design;
    class Cache {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new Cache((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (Cache._spec ??= {
                PortSymbol: ['PortSymbol', new xmlTransformer_1.OptionalArg([PortSymbol])],
                ERCSymbol: ['ERCSymbol', new xmlTransformer_1.OptionalArg([ERCSymbol])],
                OffPageSymbol: ['OffPageSymbol', new xmlTransformer_1.OptionalArg([OffPageSymbol])],
                GlobalSymbol: ['GlobalSymbol', new xmlTransformer_1.OptionalArg([GlobalSymbol])],
                TitleBlockSymbol: ['TitleBlockSymbol', new xmlTransformer_1.OptionalArg([TitleBlockSymbol])],
                Package: ['Package', new xmlTransformer_1.OptionalArg([Package])],
            })));
        }
    }
    OrCadDSNClasses.Cache = Cache;
    class DefaultPageRec {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new DefaultPageRec((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (DefaultPageRec._spec ??= {
                ANSIGridRefs: ['$ANSIGridRefs', 'number'],
                BorderDisplayed: ['$BorderDisplayed', 'number'],
                BorderPrinted: ['$BorderPrinted', 'number'],
                GridRefDisplayed: ['$GridRefDisplayed', 'number'],
                GridRefPrinted: ['$GridRefPrinted', 'number'],
                HorizontalLabelCount: ['$HorizontalLabelCount', 'number'],
                HorizontalLabelIsAscending: ['$HorizontalLabelIsAscending', 'number'],
                HorizontalLabelIsChar: ['$HorizontalLabelIsChar', 'number'],
                HorizontalLabelWidth: ['$HorizontalLabelWidth', 'number'],
                IsMetric: ['$IsMetric', 'number'],
                PinToPin: ['$PinToPin', 'number'],
                TitleBlockDisplayed: ['$TitleBlockDisplayed', 'number'],
                TitleBlockPrinted: ['$TitleBlockPrinted', 'number'],
                VerticalLabelCount: ['$VerticalLabelCount', 'number'],
                VerticalLabelIsAscending: ['$VerticalLabelIsAscending', 'number'],
                VerticalLabelIsChar: ['$VerticalLabelIsChar', 'number'],
                VerticalLabelWidth: ['$VerticalLabelWidth', 'number'],
            })));
        }
    }
    OrCadDSNClasses.DefaultPageRec = DefaultPageRec;
    class DefaultPartFieldMapping {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new DefaultPartFieldMapping((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (DefaultPartFieldMapping._spec ??= {
                Index: ['$index', 'number'],
                Value: ['$val', 'string'],
            })));
        }
    }
    OrCadDSNClasses.DefaultPartFieldMapping = DefaultPartFieldMapping;
    class DefaultValues {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new DefaultValues((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (DefaultValues._spec ??= {
                DefaultFont: ['DefaultFont', [Font]],
                DefaultPageRec: ['DefaultPageRec', new xmlTransformer_1.OptionalArg(DefaultPageRec)],
                DefaultPlacedInstIsPrimitive: [
                    'DefaultPlacedInstIsPrimitive',
                    new xmlTransformer_1.OptionalArg((xml, key) => (0, xmlutil_1.xmlNum)(xml[key]?.Defn?.$val)),
                ],
                DefaultDrawnInstIsPrimitive: [
                    'DefaultDrawnInstIsPrimitive',
                    new xmlTransformer_1.OptionalArg((xml, key) => (0, xmlutil_1.xmlNum)(xml[key]?.Defn?.$val)),
                ],
                DefaultPartFieldMappings: ['DefaultPartFieldMapping', new xmlTransformer_1.OptionalArg([DefaultPartFieldMapping])],
            })));
        }
    }
    OrCadDSNClasses.DefaultValues = DefaultValues;
    class Font {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new Font((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (Font._spec ??= {
                Charset: ['$charset', 'number'],
                Escapement: ['$escapement', 'number'],
                Index: ['$index', new xmlTransformer_1.OptionalArg('number')],
                Height: ['$height', 'number'],
                Italic: ['$italic', 'number'],
                Name: ['$name', 'string'],
                Orientation: ['$orientation', 'number'],
                Weight: ['$weight', 'number'],
                Width: ['$width', 'number'],
            })));
        }
    }
    OrCadDSNClasses.Font = Font;
    class Color {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new Color((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (Color._spec ??= {
                Value: ['$val', 'number'],
            })));
        }
    }
    OrCadDSNClasses.Color = Color;
    class DisplayType {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new DisplayType((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (DisplayType._spec ??= {
                ValueIfValueExist: ['$ValueIfValueExist', 'number'],
                Value: ['$val', 'number'],
            })));
        }
    }
    OrCadDSNClasses.DisplayType = DisplayType;
    class BoundingBox {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new BoundingBox((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (BoundingBox._spec ??= {
                X1: ['$x1', 'number'],
                X2: ['$x2', 'number'],
                Y1: ['$y1', 'number'],
                Y2: ['$y2', 'number'],
            })));
        }
    }
    OrCadDSNClasses.BoundingBox = BoundingBox;
    class Line {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new Line((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (Line._spec ??= {
                LineStyle: ['$lineStyle', 'number'],
                LineWidth: ['$lineWidth', 'number'],
                X1: ['$x1', 'number'],
                X2: ['$x2', 'number'],
                Y1: ['$y1', 'number'],
                Y2: ['$y2', 'number'],
            })));
        }
    }
    OrCadDSNClasses.Line = Line;
    class SymbolDisplayProperty {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new SymbolDisplayProperty((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (SymbolDisplayProperty._spec ??= {
                LocX: ['$locX', 'number'],
                LocY: ['$locY', 'number'],
                Name: ['$name', 'string'],
                Rotation: ['$rotation', 'number'],
                TextJustification: ['$textJustification', 'number'],
                Font: ['PropFont', Font],
                Color: ['PropColor', Color],
                DisplayType: ['PropDispType', DisplayType],
            })));
        }
    }
    OrCadDSNClasses.SymbolDisplayProperty = SymbolDisplayProperty;
    class SymbolPinScalar {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new SymbolPinScalar((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (SymbolPinScalar._spec ??= {
                HotptX: ['$hotptX', 'number'],
                HotptY: ['$hotptY', 'number'],
                Name: ['$name', 'string'],
                Position: ['$position', 'number'],
                StartX: ['$startX', 'number'],
                StartY: ['$startY', 'number'],
                Type: ['$type', new xmlTransformer_1.OptionalArg('number')],
                Visible: ['$visible', new xmlTransformer_1.OptionalArg('number')],
                IsLong: ['IsLong', new xmlTransformer_1.OptionalArg((xml, key) => (0, xmlutil_1.xmlBool)(xml[key]?.Defn?.$val))],
                IsClock: ['IsClock', (xml, key) => (0, xmlutil_1.xmlBool)(xml[key]?.Defn?.$val)],
                IsDot: ['IsDot', (xml, key) => (0, xmlutil_1.xmlBool)(xml[key]?.Defn?.$val)],
                IsLeftPointing: ['IsLeftPointing', new xmlTransformer_1.OptionalArg((xml, key) => (0, xmlutil_1.xmlBool)(xml[key]?.Defn?.$val))],
                IsRightPointing: ['IsRightPointing', new xmlTransformer_1.OptionalArg((xml, key) => (0, xmlutil_1.xmlBool)(xml[key]?.Defn?.$val))],
                IsNetStyle: ['IsNetStyle', (xml, key) => (0, xmlutil_1.xmlBool)(xml[key]?.Defn?.$val)],
                IsNoConnect: ['IsNoConnect', (xml, key) => (0, xmlutil_1.xmlBool)(xml[key]?.Defn?.$val)],
                IsGlobal: ['IsGlobal', (xml, key) => (0, xmlutil_1.xmlBool)(xml[key]?.Defn?.$val)],
                IsNumberVisible: ['IsNumberVisible', new xmlTransformer_1.OptionalArg((xml, key) => (0, xmlutil_1.xmlBool)(xml[key]?.Defn?.$val))],
                PinUserProperties: ['PinUserProp', new xmlTransformer_1.OptionalArg([UserProperty])],
                PinDisplayProperties: ['PinDisplayProp', new xmlTransformer_1.OptionalArg([SymbolDisplayProperty])],
            })));
        }
    }
    OrCadDSNClasses.SymbolPinScalar = SymbolPinScalar;
    class Ellipse {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new Ellipse((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (Ellipse._spec ??= {
                FillStyle: ['$fillStyle', 'number'],
                HatchStyle: ['$hatchStyle', 'number'],
                LineStyle: ['$lineStyle', 'number'],
                LineWidth: ['$lineWidth', 'number'],
                X1: ['$x1', 'number'],
                X2: ['$x2', 'number'],
                Y1: ['$y1', 'number'],
                Y2: ['$y2', 'number'],
            })));
        }
    }
    OrCadDSNClasses.Ellipse = Ellipse;
    class ElementWithGeometries {
        static TransformArgs() {
            return {
                Line: ['Line', new xmlTransformer_1.OptionalArg([Line])],
                Rectangle: ['Rect', new xmlTransformer_1.OptionalArg([Rectangle])],
                Ellipse: ['Ellipse', new xmlTransformer_1.OptionalArg([Ellipse])],
                Polygon: ['Polygon', new xmlTransformer_1.OptionalArg([Polygon])],
                Polyline: ['Polyline', new xmlTransformer_1.OptionalArg([Polyline])],
                Arc: ['Arc', new xmlTransformer_1.OptionalArg([Arc])],
                CommentText: ['CommentText', new xmlTransformer_1.OptionalArg([CommentText])],
                Bitmap: ['Bitmap', new xmlTransformer_1.OptionalArg([Bitmap])],
            };
        }
    }
    class Polygon {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new Polygon((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (Polygon._spec ??= {
                FillStyle: ['$fillStyle', 'number'],
                HatchStyle: ['$hatchStyle', 'number'],
                LineStyle: ['$lineStyle', 'number'],
                LineWidth: ['$lineWidth', 'number'],
                PolygonPoint: ['PolygonPoint', [XYPoint]],
            })));
        }
    }
    OrCadDSNClasses.Polygon = Polygon;
    class Polyline {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new Polyline((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (Polyline._spec ??= {
                ArrowHeadSize: ['$arrowHeadSize', new xmlTransformer_1.OptionalArg('number')],
                EndShape: ['$endShape', new xmlTransformer_1.OptionalArg('number')],
                LineStyle: ['$lineStyle', 'number'],
                LineWidth: ['$lineWidth', 'number'],
                PolylinePoint: ['PolylinePoint', [XYPoint]],
                StartShape: ['$startShape', new xmlTransformer_1.OptionalArg('number')],
            })));
        }
    }
    OrCadDSNClasses.Polyline = Polyline;
    class Arc {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new Arc((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (Arc._spec ??= {
                EndX: ['$endX', 'number'],
                EndY: ['$endY', 'number'],
                LineStyle: ['$lineStyle', 'number'],
                LineWidth: ['$lineWidth', 'number'],
                StartX: ['$startX', 'number'],
                StartY: ['$startY', 'number'],
                X1: ['$x1', 'number'],
                X2: ['$x2', 'number'],
                Y1: ['$y1', 'number'],
                Y2: ['$y2', 'number'],
            })));
        }
    }
    OrCadDSNClasses.Arc = Arc;
    class ERCSymbol extends ElementWithGeometries {
        constructor(from) {
            super();
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new ERCSymbol((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (ERCSymbol._spec ??= {
                Name: ['$name', 'string'],
                SourceLibName: ['$sourceLibName', 'string'],
                BoundingBox: ['SymbolBBox', BoundingBox],
                ...ElementWithGeometries.TransformArgs(),
            })));
        }
    }
    OrCadDSNClasses.ERCSymbol = ERCSymbol;
    class GlobalSymbol extends ElementWithGeometries {
        constructor(from) {
            super();
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new GlobalSymbol((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (GlobalSymbol._spec ??= {
                ...ElementWithGeometries.TransformArgs(),
                Name: ['$name', 'string'],
                SourceLibName: ['$sourceLibName', 'string'],
                BoundingBox: ['SymbolBBox', BoundingBox],
                PinScalar: ['SymbolPinScalar', [SymbolPinScalar]],
                SymbolDisplayProperty: ['SymbolDisplayProp', new xmlTransformer_1.OptionalArg(SymbolDisplayProperty)],
                Line: ['Line', [Line]],
                SymbolUserProperties: ['SymbolUserProp', new xmlTransformer_1.OptionalArg([UserProperty])],
            })));
        }
    }
    OrCadDSNClasses.GlobalSymbol = GlobalSymbol;
    class OffPageSymbol extends ElementWithGeometries {
        constructor(from) {
            super();
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new OffPageSymbol((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (OffPageSymbol._spec ??= {
                ...ElementWithGeometries.TransformArgs(),
                Name: ['$name', 'string'],
                SourceLibName: ['$sourceLibName', 'string'],
                SymbolDisplayProperty: ['SymbolDisplayProp', new xmlTransformer_1.OptionalArg(SymbolDisplayProperty)],
                BoundingBox: ['SymbolBBox', BoundingBox],
                PinScalar: ['SymbolPinScalar', [SymbolPinScalar]],
                SymbolUserProperties: ['SymbolUserProp', new xmlTransformer_1.OptionalArg([UserProperty])],
            })));
        }
    }
    OrCadDSNClasses.OffPageSymbol = OffPageSymbol;
    class UserProperty {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new UserProperty((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (UserProperty._spec ??= {
                Name: ['$name', 'string'],
                Value: ['$val', 'string'],
                UserEdit: ['$useredit', new xmlTransformer_1.OptionalArg('number')],
            })));
        }
    }
    OrCadDSNClasses.UserProperty = UserProperty;
    class CommentText {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new CommentText((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (CommentText._spec ??= {
                DbId: ['$dbId', new xmlTransformer_1.OptionalArg('number')],
                LocX: ['$locX', 'number'],
                LocY: ['$locY', 'number'],
                Name: ['$name', 'string'],
                TextJustification: ['$textJustification', 'number'],
                Rotation: ['$rotation', new xmlTransformer_1.OptionalArg('number')],
                X1: ['$x1', 'number'],
                X2: ['$x2', 'number'],
                Y1: ['$y1', 'number'],
                Y2: ['$y2', 'number'],
                Font: ['TextFont', Font],
                Color: ['$color', new xmlTransformer_1.OptionalArg('number')],
            })));
        }
    }
    OrCadDSNClasses.CommentText = CommentText;
    class Rectangle {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new Rectangle((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (Rectangle._spec ??= {
                FillStyle: ['$fillStyle', 'number'],
                HatchStyle: ['$hatchStyle', 'number'],
                LineStyle: ['$lineStyle', 'number'],
                LineWidth: ['$lineWidth', 'number'],
                X1: ['$x1', 'number'],
                X2: ['$x2', 'number'],
                Y1: ['$y1', 'number'],
                Y2: ['$y2', 'number'],
            })));
        }
    }
    OrCadDSNClasses.Rectangle = Rectangle;
    class Bitmap {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new Bitmap((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (Bitmap._spec ??= {
                LocX: ['$locX', 'number'],
                LocY: ['$locY', 'number'],
                Value: ['$val', 'string'],
                X1: ['$x1', 'number'],
                X2: ['$x2', 'number'],
                Y1: ['$y1', 'number'],
                Y2: ['$y2', 'number'],
            })));
        }
    }
    OrCadDSNClasses.Bitmap = Bitmap;
    class TitleBlockSymbol extends ElementWithGeometries {
        constructor(from) {
            super();
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new TitleBlockSymbol((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (TitleBlockSymbol._spec ??= {
                ...ElementWithGeometries.TransformArgs(),
                Name: ['$name', new xmlTransformer_1.OptionalArg('string')],
                SourceLibName: ['$sourceLibName', new xmlTransformer_1.OptionalArg('string')],
                SymbolDisplayProperty: ['SymbolDisplayProp', new xmlTransformer_1.OptionalArg([SymbolDisplayProperty])],
                SymbolUserProperty: ['SymbolUserProp', new xmlTransformer_1.OptionalArg([UserProperty])],
                BoundingBox: ['SymbolBBox', new xmlTransformer_1.OptionalArg(BoundingBox)],
            })));
        }
    }
    OrCadDSNClasses.TitleBlockSymbol = TitleBlockSymbol;
    class PinNumber {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new PinNumber((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (PinNumber._spec ??= {
                Number: ['$number', 'string'],
                Position: ['$position', 'number'],
            })));
        }
    }
    OrCadDSNClasses.PinNumber = PinNumber;
    class PhysicalPart {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new PhysicalPart((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (PhysicalPart._spec ??= {
                PinNumber: ['PinNumber', new xmlTransformer_1.OptionalArg([PinNumber])],
                PinSwap: ['PinSwap', new xmlTransformer_1.OptionalArg([PinSwap])],
            })));
        }
    }
    OrCadDSNClasses.PhysicalPart = PhysicalPart;
    class PinSwap {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new PinSwap((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (PinSwap._spec ??= {
                Position: ['$position', 'number'],
                SwapId: ['$swapid', 'number'],
            })));
        }
    }
    OrCadDSNClasses.PinSwap = PinSwap;
    class SymbolVector {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new SymbolVector((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (SymbolVector._spec ??= {
                LocX: ['$locX', 'number'],
                LocY: ['$locY', 'number'],
                Name: ['$name', 'string'],
                Polyline: ['Polyline', Polyline],
            })));
        }
    }
    OrCadDSNClasses.SymbolVector = SymbolVector;
    class NormalView extends ElementWithGeometries {
        constructor(from) {
            super();
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new NormalView((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (NormalView._spec ??= {
                ...ElementWithGeometries.TransformArgs(),
                Suffix: ['$suffix', 'string'],
                SymbolColor: ['SymbolColor', Color],
                BoundingBox: ['SymbolBBox', BoundingBox],
                IsPinNumbersVisible: [
                    'IsPinNumbersVisible',
                    new xmlTransformer_1.OptionalArg((xml, key) => xml[key]?.Defn?.$val === undefined ? undefined : (0, xmlutil_1.xmlBool)(xml[key]?.Defn?.$val)),
                ],
                IsPinNamesRotated: [
                    'IsPinNamesRotated',
                    new xmlTransformer_1.OptionalArg((xml, key) => xml[key]?.Defn?.$val === undefined ? undefined : (0, xmlutil_1.xmlBool)(xml[key]?.Defn?.$val)),
                ],
                IsPinNamesVisible: [
                    'IsPinNamesVisible',
                    new xmlTransformer_1.OptionalArg((xml, key) => xml[key]?.Defn?.$val === undefined ? undefined : (0, xmlutil_1.xmlBool)(xml[key]?.Defn?.$val)),
                ],
                ContentsLibName: ['ContentsLibName', (xml, key) => xml[key]?.Defn?.$name],
                ContentsViewName: ['ContentsViewName', (xml, key) => xml[key]?.Defn?.$name],
                ContentsViewType: ['ContentsViewType', (xml, key) => (0, xmlutil_1.xmlInt)(xml[key]?.Defn?.$type)],
                PartValue: ['PartValue', (xml, key) => xml[key]?.Defn?.$name],
                Reference: ['Reference', (xml, key) => xml[key]?.Defn?.$name],
                PinScalar: ['SymbolPinScalar', new xmlTransformer_1.OptionalArg([SymbolPinScalar])],
                PinBus: ['SymbolPinBus', new xmlTransformer_1.OptionalArg([SymbolPinScalar])],
                SymbolVector: ['SymbolVector', new xmlTransformer_1.OptionalArg([SymbolVector])],
                SymbolDisplayProperty: ['SymbolDisplayProp', new xmlTransformer_1.OptionalArg([SymbolDisplayProperty])],
                UserProperties: ['SymbolUserProp', new xmlTransformer_1.OptionalArg([UserProperty])],
            })));
        }
    }
    OrCadDSNClasses.NormalView = NormalView;
    class ConvertView extends ElementWithGeometries {
        constructor(from) {
            super();
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new ConvertView((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (ConvertView._spec ??= {
                ...ElementWithGeometries.TransformArgs(),
                Suffix: ['$suffix', 'string'],
                SymbolColor: ['SymbolColor', Color],
                BoundingBox: ['SymbolBBox', BoundingBox],
                IsPinNumbersVisible: [
                    'IsPinNumbersVisible',
                    new xmlTransformer_1.OptionalArg((xml, key) => xml[key]?.Defn?.$val === undefined ? undefined : (0, xmlutil_1.xmlBool)(xml[key]?.Defn?.$val)),
                ],
                IsPinNamesRotated: [
                    'IsPinNamesRotated',
                    new xmlTransformer_1.OptionalArg((xml, key) => xml[key]?.Defn?.$val === undefined ? undefined : (0, xmlutil_1.xmlBool)(xml[key]?.Defn?.$val)),
                ],
                IsPinNamesVisible: [
                    'IsPinNamesVisible',
                    new xmlTransformer_1.OptionalArg((xml, key) => xml[key]?.Defn?.$val === undefined ? undefined : (0, xmlutil_1.xmlBool)(xml[key]?.Defn?.$val)),
                ],
                ContentsLibName: ['ContentsLibName', (xml, key) => xml[key]?.Defn?.$name],
                ContentsViewName: ['ContentsViewName', (xml, key) => xml[key]?.Defn?.$name],
                ContentsViewType: ['ContentsViewType', (xml, key) => (0, xmlutil_1.xmlInt)(xml[key]?.Defn?.$type)],
                PartValue: ['PartValue', (xml, key) => xml[key]?.Defn?.$name],
                Reference: ['Reference', (xml, key) => xml[key]?.Defn?.$name],
                PinScalar: ['SymbolPinScalar', new xmlTransformer_1.OptionalArg([SymbolPinScalar])],
                PinBus: ['SymbolPinBus', new xmlTransformer_1.OptionalArg([SymbolPinScalar])],
                SymbolVector: ['SymbolVector', new xmlTransformer_1.OptionalArg([SymbolVector])],
                SymbolDisplayProperty: ['SymbolDisplayProp', new xmlTransformer_1.OptionalArg([SymbolDisplayProperty])],
                UserProperties: ['SymbolUserProp', new xmlTransformer_1.OptionalArg([UserProperty])],
            })));
        }
    }
    OrCadDSNClasses.ConvertView = ConvertView;
    class LibPart {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new LibPart((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (LibPart._spec ??= {
                CellName: ['$CellName', new xmlTransformer_1.OptionalArg('string')],
                NormalView: ['NormalView', new xmlTransformer_1.OptionalArg([NormalView])],
                PhysicalPart: ['PhysicalPart', new xmlTransformer_1.OptionalArg([PhysicalPart])],
                ConvertView: ['ConvertView', new xmlTransformer_1.OptionalArg([ConvertView])],
            })));
        }
    }
    OrCadDSNClasses.LibPart = LibPart;
    class Package {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new Package((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (Package._spec ??= {
                AlphabeticNumbering: ['$alphabeticNumbering', 'number'],
                IsHomogeneous: ['$isHomogeneous', 'boolean'],
                Name: ['$name', 'string'],
                PcbFootprint: ['$pcbFootprint', 'string'],
                PcbLib: ['$pcbLib', 'string'],
                RefdesPrefix: ['$refdesPrefix', 'string'],
                SourceLibName: ['$sourceLibName', 'string'],
                LibPart: ['LibPart', [LibPart]],
            })));
        }
    }
    OrCadDSNClasses.Package = Package;
    class BundleMember {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new BundleMember((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (BundleMember._spec ??= {
                Name: ['$name', 'string'],
                Type: ['$type', 'number'],
            })));
        }
    }
    OrCadDSNClasses.BundleMember = BundleMember;
    class Bundle {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new Bundle((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (Bundle._spec ??= {
                Name: ['$name', 'string'],
                Member: ['BundleMember', [BundleMember]],
            })));
        }
    }
    OrCadDSNClasses.Bundle = Bundle;
    class Netgroup {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new Netgroup((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (Netgroup._spec ??= {
                Bundle: ['Bundle', [Bundle]],
            })));
        }
    }
    OrCadDSNClasses.Netgroup = Netgroup;
    class WireScalar {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new WireScalar((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (WireScalar._spec ??= {
                DbId: ['$dbId', 'number'],
                EndX: ['$endX', 'number'],
                EndY: ['$endY', 'number'],
                Name: ['$name', 'string'],
                StartX: ['$startX', 'number'],
                StartY: ['$startY', 'number'],
                Color: ['WireColor', Color],
                LineStyle: ['WireLineStyle', (xml, key) => (0, xmlutil_1.xmlInt)(xml[key]?.Defn?.$val)],
                LineWidth: ['WireLineWidth', (xml, key) => (0, xmlutil_1.xmlInt)(xml[key]?.Defn?.$val)],
                BoundingBox: ['WireBBox', BoundingBox],
                DisplayProperty: ['WireDisplayProp', new xmlTransformer_1.OptionalArg([GlobalDisplayProperty])],
                UserProperty: ['WireUserProp', new xmlTransformer_1.OptionalArg([UserProperty])],
                Alias: ['Alias', new xmlTransformer_1.OptionalArg([Alias])],
                Junction: ['Junction', new xmlTransformer_1.OptionalArg([Junction])],
            })));
        }
    }
    OrCadDSNClasses.WireScalar = WireScalar;
    class Junction {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new Junction((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (Junction._spec ??= {
                LocX: ['$locX', 'number'],
                LocY: ['$locY', 'number'],
            })));
        }
    }
    OrCadDSNClasses.Junction = Junction;
    class WireBus extends WireScalar {
        constructor(from) {
            super(from);
        }
        static FromXml(arg, opts) {
            return new WireBus((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (WireBus._wireBusSpec ??= {
                DbId: ['$dbId', 'number'],
                EndX: ['$endX', 'number'],
                EndY: ['$endY', 'number'],
                Name: ['$name', 'string'],
                StartX: ['$startX', 'number'],
                StartY: ['$startY', 'number'],
                Color: ['WireColor', Color],
                LineStyle: ['WireLineStyle', 'number'],
                LineWidth: ['WireLineWidth', 'number'],
                BoundingBox: ['WireBBox', BoundingBox],
                DisplayProperty: ['WireDisplayProp', new xmlTransformer_1.OptionalArg([GlobalDisplayProperty])],
                UserProperty: ['WireUserProp', new xmlTransformer_1.OptionalArg([UserProperty])],
                Alias: ['Alias', new xmlTransformer_1.OptionalArg([Alias])],
                Junction: ['Junction', new xmlTransformer_1.OptionalArg([Junction])],
            })));
        }
    }
    OrCadDSNClasses.WireBus = WireBus;
    class Alias {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new Alias((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (Alias._spec ??= {
                Color: ['$color', new xmlTransformer_1.OptionalArg('number')],
                DbId: ['$dbId', new xmlTransformer_1.OptionalArg('number')],
                LocX: ['$locX', new xmlTransformer_1.OptionalArg('number')],
                LocY: ['$locY', new xmlTransformer_1.OptionalArg('number')],
                Name: ['$name', new xmlTransformer_1.OptionalArg('string')],
                Rotation: ['$rotation', new xmlTransformer_1.OptionalArg('number')],
                BoundingBox: ['AliasBBox', new xmlTransformer_1.OptionalArg(BoundingBox)],
                Font: ['AliasFont', new xmlTransformer_1.OptionalArg(Font)],
                BundleOwner: ['BundleOwner', new xmlTransformer_1.OptionalArg((xml, key) => xml[key]?.Defn?.$val)],
            }), true));
        }
    }
    OrCadDSNClasses.Alias = Alias;
    class NetScalar {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new NetScalar((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (NetScalar._spec ??= {
                NetColor: ['$NetColor', 'number'],
                NetLineStyle: ['$NetLineStyle', 'number'],
                NetLineWidth: ['$NetLineWidth', 'number'],
                Name: ['$name', 'string'],
                WireScalars: ['WireScalar', new xmlTransformer_1.OptionalArg([WireScalar])],
            })));
        }
    }
    OrCadDSNClasses.NetScalar = NetScalar;
    class NetBus {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new NetBus((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (NetBus._spec ??= {
                NetColor: ['$NetColor', 'number'],
                NetLineStyle: ['$NetLineStyle', 'number'],
                NetLineWidth: ['$NetLineWidth', 'number'],
                Name: ['$name', 'string'],
                WireBus: ['WireBus', new xmlTransformer_1.OptionalArg([WireScalar])],
                NetScalar: ['NetScalar', new xmlTransformer_1.OptionalArg([NetScalar])],
            })));
        }
    }
    OrCadDSNClasses.NetBus = NetBus;
    class GlobalDisplayProperty {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new GlobalDisplayProperty((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (GlobalDisplayProperty._spec ??= {
                DbId: ['$dbId', 'number'],
                LocX: ['$locX', 'number'],
                LocY: ['$locY', 'number'],
                Name: ['$name', 'string'],
                Rotation: ['$rotation', 'number'],
                TextJustification: ['$textJustification', 'number'],
                Font: ['PropFont', Font],
                Color: ['PropColor', Color],
                DisplayType: ['PropDispType', DisplayType],
            })));
        }
    }
    OrCadDSNClasses.GlobalDisplayProperty = GlobalDisplayProperty;
    class Global {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new Global((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (Global._spec ??= {
                Color: ['$color', 'number'],
                DbId: ['$dbId', 'number'],
                LibName: ['$libName', 'string'],
                LocX: ['$locX', 'number'],
                LocY: ['$locY', 'number'],
                Mirror: ['$mirror', 'number'],
                Name: ['$name', 'string'],
                Rotation: ['$rotation', 'number'],
                SymbolName: ['$symbolName', 'string'],
                DisplayProperty: ['GlobalDisplayProp', new xmlTransformer_1.OptionalArg(GlobalDisplayProperty)],
                UserProperty: ['GlobalUserProp', new xmlTransformer_1.OptionalArg([UserProperty])],
            })));
        }
    }
    OrCadDSNClasses.Global = Global;
    class TitleBlockDisplayProperty {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new TitleBlockDisplayProperty((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (TitleBlockDisplayProperty._spec ??= {
                DbId: ['$dbId', 'number'],
                LocX: ['$locX', 'number'],
                LocY: ['$locY', 'number'],
                Name: ['$name', 'string'],
                Rotation: ['$rotation', 'number'],
                TextJustification: ['$textJustification', 'number'],
                Font: ['PropFont', Font],
                Color: ['PropColor', Color],
                DisplayType: ['PropDispType', DisplayType],
            })));
        }
    }
    OrCadDSNClasses.TitleBlockDisplayProperty = TitleBlockDisplayProperty;
    class TitleBlock {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new TitleBlock((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (TitleBlock._spec ??= {
                Color: ['$color', 'number'],
                DbId: ['$dbId', 'number'],
                LibName: ['$libName', 'string'],
                LocX: ['$locX', 'number'],
                LocY: ['$locY', 'number'],
                Name: ['$name', 'string'],
                Rotation: ['$rotation', 'number'],
                SymbolName: ['$symbolName', 'string'],
                KeepInLowerRightCorner: ['KeepInLowerRightCorner', (xml, key) => (0, xmlutil_1.xmlBool)(xml[key]?.Defn?.$val)],
                PageCount: ['PageCount', (xml, key) => (0, xmlutil_1.xmlInt)(xml[key]?.Defn?.$count)],
                PageNumber: ['PageNumber', (xml, key) => (0, xmlutil_1.xmlInt)(xml[key]?.Defn?.$val)],
                DisplayProperty: ['TitleBlockDisplayProp', new xmlTransformer_1.OptionalArg([TitleBlockDisplayProperty])],
                UserProperty: ['TitleBlockUserProp', new xmlTransformer_1.OptionalArg([UserProperty])],
            })));
        }
    }
    OrCadDSNClasses.TitleBlock = TitleBlock;
    class PartInstDisplayProperty {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new PartInstDisplayProperty((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (PartInstDisplayProperty._spec ??= {
                DbId: ['$dbId', 'number'],
                LocX: ['$locX', 'number'],
                LocY: ['$locY', 'number'],
                Name: ['$name', 'string'],
                Rotation: ['$rotation', 'number'],
                TextJustification: ['$textJustification', 'number'],
                UserEdit: ['$useredit', new xmlTransformer_1.OptionalArg((xml, key) => (0, xmlutil_1.xmlBool)(xml[key]?.Defn?.$val))],
                Font: ['PropFont', Font],
                Color: ['PropColor', Color],
                DisplayType: ['PropDispType', DisplayType],
            })));
        }
    }
    OrCadDSNClasses.PartInstDisplayProperty = PartInstDisplayProperty;
    class PortInstScalar {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            const { $RecordedX, $RecordedY, $RecordedWireDbId, $recordedX, $recordedY, $recordedWireDbId, ...xmlDefn } = arg.Defn;
            const xmlArg = { ...arg, Defn: xmlDefn };
            return new PortInstScalar((0, xmlTransformer_1.transformXmlArgs)(xmlArg, opts, (PortInstScalar._spec ??= {
                IsPlacedInstPin: ['$IsPlacedInstPin', 'boolean'],
                DbId: ['$dbId', 'number'],
                HotptX: ['$hotptX', 'number'],
                HotptY: ['$hotptY', 'number'],
                Name: ['$name', 'string'],
                Position: ['$position', 'number'],
                StartX: ['$startX', 'number'],
                StartY: ['$startY', 'number'],
                Type: ['$type', 'number'],
                Visible: ['$visible', 'boolean'],
                IsNoConnect: ['IsNoConnect', (xml, key) => (0, xmlutil_1.xmlBool)(xml[key]?.Defn?.$val)],
                UserProperty: ['PortInstUserProp', new xmlTransformer_1.OptionalArg([UserProperty])],
                DisplayProperty: ['PortInstDisplayProp', new xmlTransformer_1.OptionalArg([PartInstDisplayProperty])],
            })));
        }
    }
    OrCadDSNClasses.PortInstScalar = PortInstScalar;
    class PartInst {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new PartInst((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (PartInst._spec ??= {
                Color: ['$color', 'number'],
                DbId: ['$dbId', 'number'],
                DeviceDesignator: ['$deviceDesignator', 'string'],
                LibName: ['$libName', 'string'],
                LocX: ['$locX', 'number'],
                LocY: ['$locY', 'number'],
                Mirror: ['$mirror', 'number'],
                Name: ['$name', 'string'],
                PkgName: ['$pkgName', 'string'],
                PowerPinsVisible: ['$powerpinsvisible', 'boolean'],
                Rotation: ['$rotation', 'number'],
                GraphicName: ['GraphicName', (xml, key) => xml[key]?.Defn?.$name],
                DisplayProperty: ['PartInstDisplayProp', new xmlTransformer_1.OptionalArg([PartInstDisplayProperty])],
                UserProperty: ['PartInstUserProp', new xmlTransformer_1.OptionalArg([UserProperty])],
                ContentsLibName: ['ContentsLibName', (xml, key) => xml[key]?.Defn?.$name],
                ContentsViewName: ['ContentsViewName', (xml, key) => xml[key]?.Defn?.$name],
                ContentsViewType: ['ContentsViewType', (xml, key) => (0, xmlutil_1.xmlInt)(xml[key]?.Defn?.$type)],
                IsPrimitiveProp: ['IsPrimitiveProp', (xml, key) => (0, xmlutil_1.xmlInt)(xml[key]?.Defn?.$type)],
                PartValue: ['PartValue', (xml, key) => String(xml[key]?.Defn?.$name)],
                Reference: ['Reference', (xml, key) => xml[key]?.Defn?.$name],
                PortInstScalar: ['PortInstScalar', new xmlTransformer_1.OptionalArg([PortInstScalar])],
                PortInstBus: ['PortInstBus', new xmlTransformer_1.OptionalArg([PortInstScalar])],
                PCBLib: ['PCBLib', new xmlTransformer_1.OptionalArg((xml, key) => xml[key]?.Defn?.$name)],
            })));
        }
    }
    OrCadDSNClasses.PartInst = PartInst;
    class Schematic {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new Schematic((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (Schematic._spec ??= {
                Name: ['$name', 'string'],
                MaxDbId: ['MaxDbId', (xml, key) => (0, xmlutil_1.xmlInt)(xml[key]?.Defn?.$val)],
                DateTime: ['SchematicDateTime', DateTime],
                Page: ['Page', [SchematicPage]],
            })));
        }
    }
    OrCadDSNClasses.Schematic = Schematic;
    class PageSizeInfo {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new PageSizeInfo((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (PageSizeInfo._spec ??= {
                IsMetric: ['$IsMetric', 'boolean'],
                PinToPin: ['$PinToPin', 'number'],
                Height: ['$height', 'number'],
                Width: ['$width', 'number'],
            })));
        }
    }
    OrCadDSNClasses.PageSizeInfo = PageSizeInfo;
    class XYPoint {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new XYPoint((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (XYPoint._spec ??= {
                X: ['$x', 'number'],
                Y: ['$y', 'number'],
            })));
        }
    }
    OrCadDSNClasses.XYPoint = XYPoint;
    class DateTime {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            if (!arg.Defn) {
                throw new Error(`No Defn property found in DateTime`);
            }
            return new DateTime((0, xmlTransformer_1.transformXmlArgs)(arg, opts, {
                CreateDate: [DateTime.determineKeyPrefix(arg.Defn, '$createDate'), 'string'],
                CreateDateEpoch: [DateTime.determineKeyPrefix(arg.Defn, '$createDateEpoch'), 'number'],
                CreateTime: [this.determineKeyPrefix(arg.Defn, '$createTime'), 'string'],
                ModifyDate: [this.determineKeyPrefix(arg.Defn, '$modifyDate'), 'string'],
                ModifyDateEpoch: [this.determineKeyPrefix(arg.Defn, '$modifyDateEpoch'), 'number'],
                ModifyTime: [this.determineKeyPrefix(arg.Defn, '$modifyTime'), 'string'],
            }));
        }
        static determineKeyPrefix(arg, k) {
            const stripped = k.substring(1);
            const key = Object.keys(arg).find((k) => k.endsWith(stripped));
            if (!key) {
                throw new Error(`Could not find key for ${k} in ${JSON.stringify(arg)}`);
            }
            return key;
        }
    }
    OrCadDSNClasses.DateTime = DateTime;
    class SchematicPage {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new SchematicPage((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (SchematicPage._spec ??= {
                Name: ['$name', 'string'],
                TitleBlockDisplayed: ['TitleblockDisplayed', (xml, key) => (0, xmlutil_1.xmlBool)(xml[key]?.Defn?.$val)],
                BorderDisplayed: ['BorderDisplayed', (xml, key) => (0, xmlutil_1.xmlBool)(xml[key]?.Defn?.$val)],
                GridRefDisplayed: ['GridRefDisplayed', (xml, key) => (0, xmlutil_1.xmlBool)(xml[key]?.Defn?.$val)],
                PageSizeInfo: ['PageSizeInfo', PageSizeInfo],
                PageSize: ['PageSize', (xml, key) => xml[key]?.Defn?.$val],
                OuterBorderMargin: ['OuterBorderMagin', XYPoint],
                OuterLineStyle: ['OuterLineStyle', (xml, key) => (0, xmlutil_1.xmlInt)(xml[key]?.Defn?.$val)],
                OuterLineWidth: ['OuterLineWidth', (xml, key) => (0, xmlutil_1.xmlInt)(xml[key]?.Defn?.$val)],
                OuterBorderIsVisible: ['OuterBorderIsVisible', (xml, key) => (0, xmlutil_1.xmlBool)(xml[key]?.Defn?.$val)],
                InnerBorderMargin: ['InnerBorderMargin', XYPoint],
                InnerLineStyle: ['InnerLineStyle', (xml, key) => (0, xmlutil_1.xmlInt)(xml[key]?.Defn?.$val)],
                InnerLineWidth: ['InnerLineWidth', (xml, key) => (0, xmlutil_1.xmlInt)(xml[key]?.Defn?.$val)],
                InnerLineVisible: ['InnerLineVisible', (xml, key) => (0, xmlutil_1.xmlBool)(xml[key]?.Defn?.$val)],
                Color: ['Color', Color],
                Font: ['Font', Font],
                LabelColor: ['LabelColor', Color],
                HorizontalCount: ['HorizontalCount', (xml, key) => (0, xmlutil_1.xmlInt)(xml[key]?.Defn?.$count)],
                HorizontalWidth: ['HorizontalWidth', (xml, key) => (0, xmlutil_1.xmlInt)(xml[key]?.Defn?.$val)],
                HorizontalChar: ['HorizontalChar', (xml, key) => (0, xmlutil_1.xmlInt)(xml[key]?.Defn?.$val)],
                HorizontalVisible: ['HorizontalVisible', (xml, key) => (0, xmlutil_1.xmlBool)(xml[key]?.Defn?.$val)],
                HorizontalAscending: ['HorizontalAscending', (xml, key) => (0, xmlutil_1.xmlBool)(xml[key]?.Defn?.$val)],
                HorizontalStyle: ['HorizontalStyle', (xml, key) => (0, xmlutil_1.xmlInt)(xml[key]?.Defn?.$val)],
                HorizontalSeparatorWidth: ['HorizontalSeparatorWidth', (xml, key) => (0, xmlutil_1.xmlInt)(xml[key]?.Defn?.$val)],
                VerticalCount: ['VerticalCount', (xml, key) => (0, xmlutil_1.xmlInt)(xml[key]?.Defn?.$count)],
                VerticalWidth: ['VerticalWidth', (xml, key) => (0, xmlutil_1.xmlInt)(xml[key]?.Defn?.$val)],
                VerticalChar: ['VerticalChar', (xml, key) => (0, xmlutil_1.xmlInt)(xml[key]?.Defn?.$val)],
                VerticalVisible: ['VerticalVisible', (xml, key) => (0, xmlutil_1.xmlBool)(xml[key]?.Defn?.$val)],
                VerticalAscending: ['VerticalAscending', (xml, key) => (0, xmlutil_1.xmlBool)(xml[key]?.Defn?.$val)],
                VerticalStyle: ['VerticalStyle', (xml, key) => (0, xmlutil_1.xmlInt)(xml[key]?.Defn?.$val)],
                VerticalSeparatorWidth: ['VerticalSeparatorWidth', (xml, key) => (0, xmlutil_1.xmlInt)(xml[key]?.Defn?.$val)],
                PageDateTime: ['PageDateTime', DateTime],
                TitleBlock: ['TitleBlock', new xmlTransformer_1.OptionalArg([TitleBlock])],
                NetScalar: ['NetScalar', new xmlTransformer_1.OptionalArg([NetScalar])],
                NetBus: ['NetBus', new xmlTransformer_1.OptionalArg([NetBus])],
                Global: ['Global', new xmlTransformer_1.OptionalArg([Global])],
                PartInst: ['PartInst', new xmlTransformer_1.OptionalArg([PartInst])],
                DrawnInst: ['DrawnInst', new xmlTransformer_1.OptionalArg([DrawnInst])],
                GraphicCommentTextInst: ['GraphicCommentTextInst', new xmlTransformer_1.OptionalArg([CommentText])],
                GraphicLineInst: ['GraphicLineInst', new xmlTransformer_1.OptionalArg([GraphicLineInst])],
                GraphicBitMapInst: ['GraphicBitMapInst', new xmlTransformer_1.OptionalArg([GraphicBitMapInst])],
                GraphicOleEmbedInst: ['GraphicOleEmbedInst', new xmlTransformer_1.OptionalArg([GraphicOleEmbedInst])],
                Port: ['Port', new xmlTransformer_1.OptionalArg([Port])],
                BusEntry: ['BusEntry', new xmlTransformer_1.OptionalArg([BusEntry])],
                OffPageConnector: ['OffPageConnector', new xmlTransformer_1.OptionalArg([OffPageConnector])],
                GraphicBoxInst: ['GraphicBoxInst', new xmlTransformer_1.OptionalArg([GraphicBoxInst])],
                GraphicPolygonInst: ['GraphicPolygonInst', new xmlTransformer_1.OptionalArg([GraphicPolygonInst])],
                GraphicPolylineInst: ['GraphicPolylineInst', new xmlTransformer_1.OptionalArg([GraphicPolylineInst])],
                GraphicEllipseInst: ['GraphicEllipseInst', new xmlTransformer_1.OptionalArg([GraphicEllipseInst])],
                ERC: ['ERC', new xmlTransformer_1.OptionalArg(ERC)],
            })));
        }
    }
    OrCadDSNClasses.SchematicPage = SchematicPage;
    class ERC {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new ERC({
                something: 'something',
            });
        }
    }
    OrCadDSNClasses.ERC = ERC;
    class GraphicPolygonInst {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new GraphicPolygonInst((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (GraphicPolygonInst._spec ??= {
                Color: ['$color', 'number'],
                DbId: ['$dbId', 'number'],
                FillStyle: ['$fillStyle', 'number'],
                HatchStyle: ['$hatchStyle', 'number'],
                LineStyle: ['$lineStyle', 'number'],
                LineWidth: ['$lineWidth', 'number'],
                LocX: ['$locX', 'number'],
                LocY: ['$locY', 'number'],
                Name: ['$name', 'string'],
                Rotation: ['$rotation', 'number'],
                PolygonPoint: ['PolygonPoint', [XYPoint]],
            })));
        }
    }
    OrCadDSNClasses.GraphicPolygonInst = GraphicPolygonInst;
    class GraphicPolylineInst {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new GraphicPolylineInst((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (GraphicPolylineInst._spec ??= {
                Color: ['$color', 'number'],
                DbId: ['$dbId', 'number'],
                LineStyle: ['$lineStyle', 'number'],
                LineWidth: ['$lineWidth', 'number'],
                LocX: ['$locX', 'number'],
                LocY: ['$locY', 'number'],
                Name: ['$name', 'string'],
                Rotation: ['$rotation', 'number'],
                PolylinePoint: ['PolylinePoint', [XYPoint]],
            })));
        }
    }
    OrCadDSNClasses.GraphicPolylineInst = GraphicPolylineInst;
    class GraphicEllipseInst {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new GraphicEllipseInst((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (GraphicEllipseInst._spec ??= {
                Color: ['$color', 'number'],
                DbId: ['$dbId', 'number'],
                FillStyle: ['$fillStyle', 'number'],
                HatchStyle: ['$hatchStyle', 'number'],
                LineStyle: ['$lineStyle', 'number'],
                LineWidth: ['$lineWidth', 'number'],
                LocX: ['$locX', 'number'],
                LocY: ['$locY', 'number'],
                Name: ['$name', 'string'],
                Rotation: ['$rotation', 'number'],
                X1: ['$x1', 'number'],
                X2: ['$x2', 'number'],
                Y1: ['$y1', 'number'],
                Y2: ['$y2', 'number'],
            })));
        }
    }
    OrCadDSNClasses.GraphicEllipseInst = GraphicEllipseInst;
    class GraphicBoxInst {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new GraphicBoxInst((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (GraphicBoxInst._spec ??= {
                Color: ['$color', 'number'],
                DbId: ['$dbId', 'number'],
                FillStyle: ['$fillStyle', 'number'],
                HatchStyle: ['$hatchStyle', 'number'],
                LineStyle: ['$lineStyle', 'number'],
                LineWidth: ['$lineWidth', 'number'],
                LocX: ['$locX', 'number'],
                LocY: ['$locY', 'number'],
                Name: ['$name', 'string'],
                Rotation: ['$rotation', 'number'],
                X1: ['$x1', 'number'],
                X2: ['$x2', 'number'],
                Y1: ['$y1', 'number'],
                Y2: ['$y2', 'number'],
            })));
        }
    }
    OrCadDSNClasses.GraphicBoxInst = GraphicBoxInst;
    class OffPageConnector {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new OffPageConnector((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (OffPageConnector._spec ??= {
                Color: ['$color', new xmlTransformer_1.OptionalArg('number')],
                DbId: ['$dbId', 'number'],
                LibName: ['$libName', new xmlTransformer_1.OptionalArg('string')],
                LocX: ['$locX', 'number'],
                LocY: ['$locY', 'number'],
                Mirror: ['$mirror', new xmlTransformer_1.OptionalArg('number')],
                Name: ['$name', 'string'],
                Rotation: ['$rotation', 'number'],
                SymbolName: ['$symbolName', new xmlTransformer_1.OptionalArg('string')],
                Type: ['$type', new xmlTransformer_1.OptionalArg('number')],
                TextJustification: ['$textJustification', new xmlTransformer_1.OptionalArg('number')],
                Useredit: ['$useredit', new xmlTransformer_1.OptionalArg('number')],
                OffPageConnectorDisplayProp: ['OffPageConnectorDisplayProp', new xmlTransformer_1.OptionalArg([GlobalDisplayProperty])],
                OffPageConnectorUserProp: ['OffPageConnectorUserProp', new xmlTransformer_1.OptionalArg([UserProperty])],
            })));
        }
    }
    OrCadDSNClasses.OffPageConnector = OffPageConnector;
    class BusEntry {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new BusEntry((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (BusEntry._spec ??= {
                BusX: ['$busX', 'number'],
                BusY: ['$busY', 'number'],
                EndX: ['$endX', 'number'],
                EndY: ['$endY', 'number'],
            })));
        }
    }
    OrCadDSNClasses.BusEntry = BusEntry;
    class Port {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new Port((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (Port._spec ??= {
                Color: ['$color', new xmlTransformer_1.OptionalArg('number')],
                DbId: ['$dbId', 'number'],
                LibName: ['$libName', new xmlTransformer_1.OptionalArg('string')],
                LocX: ['$locX', 'number'],
                LocY: ['$locY', 'number'],
                Mirror: ['$mirror', new xmlTransformer_1.OptionalArg('number')],
                Name: ['$name', 'string'],
                Rotation: ['$rotation', new xmlTransformer_1.OptionalArg('number')],
                SymbolName: ['$symbolName', new xmlTransformer_1.OptionalArg('string')],
                Type: ['$type', new xmlTransformer_1.OptionalArg('number')],
                TextJustification: ['$textJustification', new xmlTransformer_1.OptionalArg('number')],
                Useredit: ['$useredit', new xmlTransformer_1.OptionalArg('number')],
                PortDisplayProp: ['PortDisplayProp', new xmlTransformer_1.OptionalArg([GlobalDisplayProperty])],
                PortUserProp: ['PortUserProp', new xmlTransformer_1.OptionalArg([UserProperty])],
            })));
        }
    }
    OrCadDSNClasses.Port = Port;
    class DrawnInstPortScalar {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new DrawnInstPortScalar((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (DrawnInstPortScalar._spec ??= {
                DbId: ['$dbId', new xmlTransformer_1.OptionalArg('number')],
                HotptX: ['$hotptX', 'number'],
                HotptY: ['$hotptY', 'number'],
                Name: ['$name', 'string'],
                StartX: ['$startX', 'number'],
                StartY: ['$startY', 'number'],
                Type: ['$type', 'number'],
                Visible: ['$visible', 'boolean'],
                IsLong: ['IsLong', (xml, key) => (0, xmlutil_1.xmlBool)(xml[key]?.Defn?.$val)],
                IsClock: ['IsClock', (xml, key) => (0, xmlutil_1.xmlBool)(xml[key]?.Defn?.$val)],
                IsDot: ['IsDot', (xml, key) => (0, xmlutil_1.xmlBool)(xml[key]?.Defn?.$val)],
                IsLeftPointing: ['IsLeftPointing', (xml, key) => (0, xmlutil_1.xmlBool)(xml[key]?.Defn?.$val)],
                IsRightPointing: ['IsRightPointing', (xml, key) => (0, xmlutil_1.xmlBool)(xml[key]?.Defn?.$val)],
                IsNetStyle: ['IsNetStyle', (xml, key) => (0, xmlutil_1.xmlBool)(xml[key]?.Defn?.$val)],
                IsGlobal: ['IsGlobal', (xml, key) => (0, xmlutil_1.xmlBool)(xml[key]?.Defn?.$val)],
                IsNoConnect: ['IsNoConnect', (xml, key) => (0, xmlutil_1.xmlBool)(xml[key]?.Defn?.$val)],
            })));
        }
    }
    OrCadDSNClasses.DrawnInstPortScalar = DrawnInstPortScalar;
    class DrawnInstPortBus {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new DrawnInstPortBus((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (DrawnInstPortBus._spec ??= {
                DbId: ['$dbId', new xmlTransformer_1.OptionalArg('number')],
                HotptX: ['$hotptX', 'number'],
                HotptY: ['$hotptY', 'number'],
                Name: ['$name', 'string'],
                StartX: ['$startX', 'number'],
                StartY: ['$startY', 'number'],
                Type: ['$type', 'number'],
                Visible: ['$visible', 'boolean'],
                UserProperties: ['PortInstUserProp', new xmlTransformer_1.OptionalArg([UserProperty])],
                IsLong: ['IsLong', (xml, key) => (0, xmlutil_1.xmlBool)(xml[key]?.Defn?.$val)],
                IsClock: ['IsClock', (xml, key) => (0, xmlutil_1.xmlBool)(xml[key]?.Defn?.$val)],
                IsDot: ['IsDot', (xml, key) => (0, xmlutil_1.xmlBool)(xml[key]?.Defn?.$val)],
                IsLeftPointing: ['IsLeftPointing', (xml, key) => (0, xmlutil_1.xmlBool)(xml[key]?.Defn?.$val)],
                IsRightPointing: ['IsRightPointing', (xml, key) => (0, xmlutil_1.xmlBool)(xml[key]?.Defn?.$val)],
                IsNetStyle: ['IsNetStyle', (xml, key) => (0, xmlutil_1.xmlBool)(xml[key]?.Defn?.$val)],
                IsGlobal: ['IsGlobal', (xml, key) => (0, xmlutil_1.xmlBool)(xml[key]?.Defn?.$val)],
                IsNoConnect: ['IsNoConnect', (xml, key) => (0, xmlutil_1.xmlBool)(xml[key]?.Defn?.$val)],
            })));
        }
    }
    OrCadDSNClasses.DrawnInstPortBus = DrawnInstPortBus;
    class DrawnInst {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new DrawnInst((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (DrawnInst._spec ??= {
                Color: ['$color', 'number'],
                DbId: ['$dbId', 'number'],
                DeviceDesignator: ['$deviceDesignator', 'string'],
                LibName: ['$libName', 'string'],
                LocX: ['$locX', 'number'],
                LocY: ['$locY', 'number'],
                Mirror: ['$mirror', 'number'],
                Name: ['$name', 'string'],
                Rotation: ['$rotation', 'number'],
                X1: ['$x1', 'number'],
                X2: ['$x2', 'number'],
                Y1: ['$y1', 'number'],
                Y2: ['$y2', 'number'],
                DisplayProperty: ['DrawnInstDisplayProp', new xmlTransformer_1.OptionalArg([GlobalDisplayProperty])],
                UserProperty: ['DrawnInstUserProp', new xmlTransformer_1.OptionalArg([UserProperty])],
                ContentsLibName: ['ContentsLibName', (xml, key) => xml[key]?.Defn?.$name],
                ContentsViewName: ['ContentsViewName', (xml, key) => xml[key]?.Defn?.$name],
                ContentsViewType: ['ContentsViewType', (xml, key) => (0, xmlutil_1.xmlInt)(xml[key]?.Defn?.$type)],
                IsPrimitiveProp: ['IsPrimitiveProp', (xml, key) => (0, xmlutil_1.xmlInt)(xml[key]?.Defn?.$type)],
                PartValue: ['PartValue', (xml, key) => String(xml[key]?.Defn?.$name)],
                Reference: ['Reference', (xml, key) => xml[key]?.Defn?.$name],
                PortInstScalar: ['PortInstScalar', new xmlTransformer_1.OptionalArg([DrawnInstPortScalar])],
                PortInstBus: ['PortInstBus', new xmlTransformer_1.OptionalArg([DrawnInstPortBus])],
            })));
        }
    }
    OrCadDSNClasses.DrawnInst = DrawnInst;
    class GraphicBitMapInst {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new GraphicBitMapInst((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (GraphicBitMapInst._spec ??= {
                DbId: ['$dbId', 'number'],
                LocX: ['$locX', 'number'],
                LocY: ['$locY', 'number'],
                Value: ['$val', 'string'],
                X1: ['$x1', 'number'],
                X2: ['$x2', 'number'],
                Y1: ['$y1', 'number'],
                Y2: ['$y2', 'number'],
            })));
        }
    }
    OrCadDSNClasses.GraphicBitMapInst = GraphicBitMapInst;
    class GraphicOleEmbedInst {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new GraphicOleEmbedInst((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (GraphicOleEmbedInst._spec ??= {
                DbId: ['$dbId', 'number'],
                LocX: ['$locX', 'number'],
                LocY: ['$locY', 'number'],
                Dib: ['$dib', 'string'],
                DibSize: ['$dibSize', 'number'],
                Value: ['$val', 'string'],
                X1: ['$x1', 'number'],
                X2: ['$x2', 'number'],
                Y1: ['$y1', 'number'],
                Y2: ['$y2', 'number'],
            })));
        }
    }
    OrCadDSNClasses.GraphicOleEmbedInst = GraphicOleEmbedInst;
    class GraphicLineInst {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new GraphicLineInst((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (GraphicLineInst._spec ??= {
                Color: ['$color', 'number'],
                DbId: ['$dbId', 'number'],
                EndX: ['$endX', 'number'],
                EndY: ['$endY', 'number'],
                LineStyle: ['$lineStyle', 'number'],
                LineWidth: ['$lineWidth', 'number'],
                LocX: ['$locX', 'number'],
                LocY: ['$locY', 'number'],
                Name: ['$name', 'string'],
                Rotation: ['$rotation', 'number'],
                StartX: ['$startX', 'number'],
                StartY: ['$startY', 'number'],
            })));
        }
    }
    OrCadDSNClasses.GraphicLineInst = GraphicLineInst;
    class CorePart {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new CorePart((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (CorePart._spec ??= {
                OccId: ['$OccId', 'number'],
                PartNumber: ['$PartNumber', 'string'],
                Reference: ['$Reference', 'string'],
                PartPresent: ['$PartPresent', new xmlTransformer_1.OptionalArg('string')],
            })));
        }
    }
    OrCadDSNClasses.CorePart = CorePart;
    class Common {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new Common((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (Common._spec ??= {
                CommonCorePart: ['CommonCorePart', [CorePart]],
            })));
        }
    }
    OrCadDSNClasses.Common = Common;
    class LinkedPart {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new LinkedPart((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (LinkedPart._spec ??= {
                Definition: ['Defn', new xmlTransformer_1.OptionalArg('string')],
                Property: ['PropNVP', new xmlTransformer_1.OptionalArg([NameValuePair])],
            })));
        }
    }
    OrCadDSNClasses.LinkedPart = LinkedPart;
    class NameValuePair {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new NameValuePair((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (NameValuePair._spec ??= {
                Name: ['$name', 'string'],
                Value: ['$value', 'string'],
            })));
        }
    }
    OrCadDSNClasses.NameValuePair = NameValuePair;
    class SubGroupName {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new SubGroupName((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (SubGroupName._spec ??= {
                Name: ['$name', 'string'],
                CorePart: ['GroupCorePart', new xmlTransformer_1.OptionalArg([CorePart])],
                LinkedPart: ['LinkedPart', new xmlTransformer_1.OptionalArg([LinkedPart])],
            })));
        }
    }
    OrCadDSNClasses.SubGroupName = SubGroupName;
    class GroupName {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new GroupName((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (GroupName._spec ??= {
                Name: ['$name', 'string'],
                SubGroupName: ['SubGroupName', [SubGroupName]],
            })));
        }
    }
    OrCadDSNClasses.GroupName = GroupName;
    class Groups {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new Groups((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (Groups._spec ??= {
                Common: ['Common', new xmlTransformer_1.OptionalArg(Common)],
                GroupName: ['GroupName', new xmlTransformer_1.OptionalArg([GroupName])],
            })));
        }
    }
    OrCadDSNClasses.Groups = Groups;
    class VariantEntry {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new VariantEntry((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (VariantEntry._spec ??= {
                BomEntry: ['$BOMEntry', 'string'],
            })));
        }
    }
    OrCadDSNClasses.VariantEntry = VariantEntry;
    class VariantName {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new VariantName((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (VariantName._spec ??= {
                BomName: ['$BOMName', 'string'],
                VariantEntry: ['VariantEntry', [VariantEntry]],
            })));
        }
    }
    OrCadDSNClasses.VariantName = VariantName;
    class BOMVariants {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new BOMVariants((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (BOMVariants._spec ??= {
                VariantName: ['VariantName', new xmlTransformer_1.OptionalArg([VariantName])],
            })));
        }
    }
    OrCadDSNClasses.BOMVariants = BOMVariants;
    class PortOccurrence {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new PortOccurrence((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (PortOccurrence._spec ??= {
                KeyType: ['$keyType', 'string'],
                RefBusMemberName: ['$refBusMemberName', 'string'],
                RefKey: ['$refKey', 'string'],
                RefPortName: ['$refPortName', 'string'],
                UserProperty: ['OccUserProp', new xmlTransformer_1.OptionalArg([UserProperty])],
                DisplayProperty: ['OccDispProp', new xmlTransformer_1.OptionalArg([GlobalDisplayProperty])],
            })));
        }
    }
    OrCadDSNClasses.PortOccurrence = PortOccurrence;
    class TitleBlockOccurrence {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new TitleBlockOccurrence((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (TitleBlockOccurrence._spec ??= {
                RefInstId: ['$refInstId', new xmlTransformer_1.OptionalArg('string')],
                UserProperty: ['OccUserProp', new xmlTransformer_1.OptionalArg([UserProperty])],
                DisplayProperty: ['OccDispProp', new xmlTransformer_1.OptionalArg([TitleBlockDisplayProperty])],
            })));
        }
    }
    OrCadDSNClasses.TitleBlockOccurrence = TitleBlockOccurrence;
    class InstOccurrence {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            const occurrence = new InstOccurrence((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (InstOccurrence._spec ??= {
                RefInstId: ['$refInstId', 'string'],
                UserProperty: ['OccUserProp', new xmlTransformer_1.OptionalArg([UserProperty])],
                DisplayProperty: ['OccDispProp', new xmlTransformer_1.OptionalArg([GlobalDisplayProperty])],
                PortOccurrence: ['PortOccurrence', new xmlTransformer_1.OptionalArg([PortOccurrence])],
                TitleBlockOccurrence: ['TitleBlockOccurrence', new xmlTransformer_1.OptionalArg([TitleBlockOccurrence])],
                InstOccurrence: ['InstOccurrence', new xmlTransformer_1.OptionalArg([InstOccurrence])],
            })));
            const normalized = (0, portOccurrenceNormalization_1.normalizePortOccurrences)(occurrence.PortOccurrence ?? []);
            occurrence.PortOccurrence = normalized.portOccurrences.map((row) => new PortOccurrence(row));
            for (const diagnostic of normalized.diagnostics) {
                opts.processingResults.innerResults.push({
                    type: 'orcad-port-occurrence',
                    message: `[port-occurrence-ambiguous] refInstId=${occurrence.RefInstId} member=${diagnostic.memberName} candidates=${diagnostic.candidateRefKeys.join(',')}`,
                    severity: sigma_engine_shared_1.BoundaryLevel.Warning,
                });
            }
            return occurrence;
        }
    }
    OrCadDSNClasses.InstOccurrence = InstOccurrence;
    class Occurrences {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new Occurrences((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (Occurrences._spec ??= {
                InstOccurrence: ['InstOccurrence', [InstOccurrence]],
            })));
        }
    }
    OrCadDSNClasses.Occurrences = Occurrences;
    class CIS {
        constructor(from) {
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new CIS((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (CIS._spec ??= {
                Definition: ['Defn', new xmlTransformer_1.OptionalArg('string')],
                Groups: ['Groups', Groups],
                BomVariants: ['BOMVariants', BOMVariants],
            })));
        }
    }
    OrCadDSNClasses.CIS = CIS;
    class PortSymbol extends ElementWithGeometries {
        constructor(from) {
            super();
            (0, xmlTransformer_1.maybeApplyProps)(this, from);
        }
        static FromXml(arg, opts) {
            return new PortSymbol((0, xmlTransformer_1.transformXmlArgs)(arg, opts, (PortSymbol._spec ??= {
                ...ElementWithGeometries.TransformArgs(),
                Name: ['$name', 'string'],
                SourceLibName: ['$sourceLibName', 'string'],
                SymbolDisplayProperty: ['SymbolDisplayProp', new xmlTransformer_1.OptionalArg(SymbolDisplayProperty)],
                BoundingBox: ['SymbolBBox', BoundingBox],
                Line: ['Line', new xmlTransformer_1.OptionalArg([Line])],
                PinScalar: ['SymbolPinScalar', new xmlTransformer_1.OptionalArg(SymbolPinScalar)],
            })));
        }
    }
    OrCadDSNClasses.PortSymbol = PortSymbol;
})(OrCadDSNClasses || (exports.OrCadDSNClasses = OrCadDSNClasses = {}));
//# sourceMappingURL=LogicalSchemaClasses.js.map